import { __read } from "tslib";
// https://en.wikipedia.org/wiki/Right-to-left
// prettier-ignore
var RTL_SCRIPTS = new Set(['Arab', 'Syrc', 'Samr', 'Mand', 'Thaa', 'Mend', 'Nkoo', 'Adlm', 'Rohg', 'Hebr']);
// prettier-ignore
var RTL_LANGS = new Set(['ae', 'ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'he', 'ku', 'mzn', 'nqo', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi']);
export function getLocaleData(locale) {
    // @ts-expect-error
    if (Intl.Locale) {
        // @ts-expect-error
        var _a = new Intl.Locale(locale).maximize(), region_1 = _a.region, script = _a.script, language_1 = _a.language;
        var direction_1 = RTL_SCRIPTS.has(script) ? 'rtl' : 'ltr';
        return {
            locale: locale,
            language: language_1,
            region: region_1,
            direction: direction_1,
            isRTL: direction_1 === 'rtl',
        };
    }
    // NOTE: region может быть undefined, если в navigator.language будет `ru` или `en`
    var _b = __read(locale.split('-'), 2), language = _b[0], region = _b[1];
    var direction = RTL_LANGS.has(language) ? 'rtl' : 'ltr';
    return {
        locale: locale,
        language: language,
        region: region,
        direction: direction,
        isRTL: direction === 'rtl',
    };
}
